import React, { useState, useContext } from "react";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import { Divider } from "rsuite";
import InputText from "../Elements/InputText.jsx";
import classes from "./NewCustomer.module.css";
import ModalOkay from "./Modals/ModalOkay";
import PermissionContext from "../../Store/permission-context";
var CryptoJS = require("crypto-js");
const NewCustomer = () => {
  const [Username, setUsername] = useState("");
  const [BusinessName, setBusinessName] = useState("");
  const [Address, setAddress] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const PCtx = useContext(PermissionContext);
  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");
  //   useEffect(() => {
  //     const getData = async () => {
  //       let Users = await PCtx.connectAxios("getallusers.php", "");
  //       setAllUsers(Users);
  //     };
  //     getData();
  //   }, []);

  const RegisterCustomer = async (e) => {
    e.preventDefault();

    let customer = {
      Username: Username.toUpperCase(),
      BusinessName: BusinessName,
      Address: Address,
      PhoneNumber: PhoneNumber,
    };

    let Response = await PCtx.connectAxios("savenewcustomer.php", customer);

    if (Response.includes("Success")) {
      setOkmessage(BusinessName + " registered successfully.");
      setOktitle("SUCCESS!");
      setShowOkAlert(true);
    }
  };

  const nextOKEvent = () => {
    setShowOkAlert(false);
    window.location.reload();
  };
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Body>
            <h5
              className="text-center "
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              <Divider className="m-0">NEW CUSTOMER REGISTRATION FORM</Divider>
            </h5>
          </Card.Body>
        </Card>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <Row className="justify-content-around my-5">
          <Col md={6} sm={11} xs={11}>
            <Card className={classes.Shadow}>
              <Card.Body>
                <h5
                  class="text-center"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  Please fill in the information below. The fields marked (*)
                  are compulsory
                </h5>
                <Form className="py-5" onSubmit={RegisterCustomer}>
                  <Row className="justify-content-around">
                    <Col md={12} sm={12} xs={12}>
                      <InputText
                        label="BusinessName"
                        myName="BusinessName"
                        myVal={BusinessName}
                        myOnChange={setBusinessName}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={12} sm={12} xs={12}>
                      <InputText
                        label="Address"
                        myName="Address"
                        myVal={Address}
                        myOnChange={setAddress}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={12} sm={12} xs={12}>
                      <InputText
                        label="PhoneNumber"
                        myName="PhoneNumber"
                        myVal={PhoneNumber}
                        myOnChange={setPhoneNumber}
                      />
                    </Col>
                  </Row>

                  <Row className="justify-content-center">
                    <Col md={4} sm={4} xs={4}>
                      <Button
                        type="submit"
                        variant="success"
                        className="w-100 mt-3"
                      >
                        Save
                      </Button>{" "}
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <ModalOkay
        message={Okmessage}
        okshow={ShowOkAlert}
        title={Oktitle}
        nextEvent={nextOKEvent}
      />
    </Row>
  );
};

export default NewCustomer;
